import { MessageEvent } from '@sa/cassius-contract';

/** Supported store actions. */
export const STORE_ACTION_TYPES = ['DHS/RECEIVE_APP_MESSAGE'] as const;
export type StoreActionType = typeof STORE_ACTION_TYPES[number];

/** Action for dispatching to the store. */
export type StoreAction = {
  type: StoreActionType;
  payload: {
    type: MessageEvent;
    data: unknown;
  };
};
